import { LktNotificationItem } from "@frontends-v3/design-system";

import { NotificationDto } from "../../../models/notifications/notification.interface";
import { formatRelativeTime } from "../../../utils/relative-time.util";

import { resolveNotificationPresentation } from "./notification-presentation.util";

/**
 * DTO do backend → view-model visual do design-system.
 *
 * Precedente estrutural: `components/content-view/utils/build-content-view-model.util.ts`.
 *
 * `now` entra por parâmetro para a função ser pura e o `timeLabel` ser testável sem congelar o
 * relógio do processo.
 */
export function buildNotificationItem(dto: NotificationDto, now: Date): LktNotificationItem {
  const presentation = resolveNotificationPresentation(dto);

  return {
    id: dto.id,
    tone: presentation.tone,
    icon: presentation.icon,
    // A frase vem pronta e decomposta do backend: nada de montar copy nem de innerHTML.
    subject: dto.subject,
    message: dto.message,
    ...(dto.body ? { body: dto.body } : {}),
    timeLabel: formatRelativeTime(dto.createdAt, now),
    read: dto.readAt !== null,
    ...(presentation.ctaLabel ? { ctaLabel: presentation.ctaLabel } : {})
  };
}
